import { render, staticRenderFns } from "./Gorseval.vue?vue&type=template&id=39fe24f7&scoped=true&"
import script from "./Gorseval.vue?vue&type=script&lang=js&"
export * from "./Gorseval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe24f7",
  null
  
)

export default component.exports